import React, { useState } from "react";
import Header from "../NavSideFoot/Header";
import Sidebar from "../NavSideFoot/Sidebar";

const AdminLayout = ({ children, currentPath, navigate }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-slate-100 text-slate-900">
      <Sidebar
        currentPath={currentPath}
        isSidebarOpen={isSidebarOpen}
        navigate={navigate}
        setIsSidebarOpen={setIsSidebarOpen}
      />
      <div className="min-h-screen lg:pl-64">
        <Header
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
        />
        <main className="px-4 pb-8 pt-20 sm:px-6 lg:px-8">{children}</main>
      </div>
    </div>
  );
};

export default AdminLayout;
